import useAccountQuery from "@/shared/hooks/useAccountQuery";
import { SystemMessage } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";
import { getMockPendingSystemMessages } from "./mock/systemMessagesMock";

// Checked again now and then so a POS that stays open still gets new messages
const REFETCH_INTERVAL = 5 * 60 * 1000;

// The messages the logged in user still has to see
const useSystemMessagesPendingQuery = ({ enabled = true } = {}) => {
  const { data: account } = useAccountQuery();
  const userId = account?.item_id;

  return useQuery<SystemMessage[]>({
    queryKey: ["systemMessagesPending", userId],
    // TODO: replace with the real endpoint once it exists, e.g.
    // get2(`internal/secure/pos/v1/system-messages/pending`)
    queryFn: () => getMockPendingSystemMessages(userId),
    enabled: enabled && userId !== undefined,
    refetchInterval: REFETCH_INTERVAL,
    refetchOnWindowFocus: false,
  });
};

export default useSystemMessagesPendingQuery;
